
import { Suspense } from 'react';
import './App.css';
import Ask_Jeeves_Geo from './Ask_Jeeves_Geo';
import Pillar from './FivePillars';
import PatentContextProvider from './context/PatentContextProvider';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


function App() {
  return (
    <PatentContextProvider>

      <div>
        <Router>
          <Routes>
            <Route path='/' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Ask_Jeeves_Geo /></Suspense>} />
            <Route path='/seven-pillars' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Pillar /></Suspense>} />
          </Routes>
        </Router>
        {/* <Ask_Jeeves_Geo/> */}
      </div>
    </PatentContextProvider>
  );
}

export default App;
